import * as React from 'react'

import {
  AppointmentStack,
  ScheduledAppointment,
} from '@user/components/Scheduling'
import type { ENTITY_TYPES } from '@sales-center/common'

import { useData } from './useData'
import Alert from '@mui/material/Alert'
import CircularProgress from '@mui/material/CircularProgress'
import { Panel } from '../atoms'

export type AppointmentsProps = {
  entityId: number
  entityType: ENTITY_TYPES
}

export function Appointments(props: AppointmentsProps) {
  const { status, appointments } = useData(props)

  const apptCount = status === 'success' ? ` (${appointments.length})` : ''
  const title = `Scheduled Appointments${apptCount}`

  return (
    <Panel icon="appointments" title={title}>
      {status === 'pending' && <CircularProgress />}

      {status === 'fail' && (
        <Alert severity="error">Failed to load Appointments.</Alert>
      )}

      {status === 'success' &&
        (appointments.length > 0 ? (
          <AppointmentStack>
            {appointments.map((appt) => (
              <ScheduledAppointment key={appt.appointmentId} appt={appt} />
            ))}
          </AppointmentStack>
        ) : (
          <Alert severity="info">
            This Opportunity has no associated Appointments.
          </Alert>
        ))}
    </Panel>
  )
}
